import LocalStorageService from "./LocalStorageService";
import MessageService from "./MessageService";

export const ALPHABET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
];

const COLORS = [
  "#e88fe8",
  "#1E90FF",
  "#8c00ff",
  "#27a3bc",
  "#FFA07A",
  "#A9A9A9",
  "#bd9d6b",
  "#FF8C00",
  "#90EE90",
  "#C71585",
  "#191970",
  "#A0522D",
  "#B0C4DE",
  "#FFD700",
  "#FF6347",
  "#008080",
  "#9966CC",
  "#E6E6FA",
  "#F8F8FF",
];

export interface LetterBadge {
  color?: string;
  label: string;
}

export default class LetterBadgeManager {
  private letterPerHash: Map<string, string> = new Map<string, string>();
  private colorPerHash: Map<string, string> = new Map<string, string>();
  private idxLetter = 0;
  private idxColor = 0;

  getLetterBadge(type: string, hash: string): LetterBadge {
    if (!type || !hash) return;

    const letter = this.letterPerHash.get(hash);

    if (!letter) {
      this.letterPerHash.set(hash, this.nextLetter());
    }

    return {
      color: LocalStorageService.getObservationType(type).color,
      label: this.letterPerHash.get(hash),
    };
  }

  getLetterBadgeRandomColor(hash: string): LetterBadge {
    if (!hash) return;

    const letter = this.letterPerHash.get(hash);

    if (!letter) {
      this.letterPerHash.set(hash, this.nextLetter());
    }

    const color = this.colorPerHash.get(hash);

    if (!color) {
      this.colorPerHash.set(hash, this.nextColor());
    }

    return {
      color: this.colorPerHash.get(hash),
      label: this.letterPerHash.get(hash),
    };
  }

  unsetTagForObs(hash: any) {
    this.letterPerHash.set(hash, null);
    this.colorPerHash.set(hash, null);
  }

  private nextColor(): string {
    if (this.colorPerHash.size == COLORS.length) {
      MessageService.error("Plus de couleur disponible");
      return "";
    }

    const idx = this.idxColor++ % COLORS.length;

    const color = COLORS[idx];
    if (LetterBadgeManager.containsValue(this.colorPerHash, color)) {
      return this.nextColor();
    }
    return color;
  }

  private nextLetter(): string {
    if (this.letterPerHash.size == ALPHABET.length) {
      MessageService.error("Plus de lettre disponible");
      return "";
    }

    const idx = this.idxLetter++ % ALPHABET.length;

    const letter = ALPHABET[idx];
    if (LetterBadgeManager.containsValue(this.letterPerHash, letter)) {
      return this.nextLetter();
    }
    return letter;
  }

  reset() {
    this.letterPerHash.clear();
    this.idxLetter = 0;
    this.idxColor = 0;
  }

  static containsValue(map: Map<string, string>, val: string): boolean {
    for (const [k, v] of map) {
      if (v === val) {
        return true;
      }
    }

    return false;
  }
}
